// removed by extract-text-webpack-plugin
module.exports = {"item":"_1NOgiK1bW3HxP_rhZXDP6E","popoverContainer":"_1QW6PHpZ6w9fbJdz4UJZMf","selected":"rhegczt_IT1lFL0yTaEIE","name":"_3F0UEQwUI8s_hb6AtQ7_FS","lockedIcon":"_31WPMHsLHPNaKs851meQKu","shown":"_2lKD4PSu_sV4pEqESgaKjA","popoverContent":"_2SDxcuiHmCd-VywZDENG-D","popoverItem":"_2VjDvir7JwzEkZtv5hYPLl"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Roles/Sidebar/style/RoleItem.pcss
// module id = 1295
// module chunks = 0